import { OutlinedInput, styled } from "@mui/material";

 const StyledInputElement = styled(OutlinedInput)(({ theme }) => ({
  padding: "8px 0",
  borderRadius: theme.spacing(1),
  height: theme.spacing(8),
  width: theme.spacing(8),
  color:
    theme.palette.mode === "dark"
      ? theme.palette.grey[300]
      : theme.palette.grey[600],
  background: theme.palette.mode === "dark" ? theme.palette.grey[900] : "#fff",
  border: `1px solid ${theme.palette.mode === "dark"
    ? theme.palette.grey[700]
    : theme.palette.border.input
    }`,
  "& input ": {
    fontFamily: `IBM Plex Sans, sans-serif`,
    fontSize: "3rem",
    fontWeight: 400,
    lineHeight: 1.5,
    textAlign: "center",
    padding: 0,
  },
  "& .MuiInputBase-root.MuiOutlinedInput-root": {
    borderRadius: theme.shape.borderRadius,
    // pr: 0,
  },
  "&:focus": {
    boxShadow: ` rgba(140, 140, 140, 0.25) 0 0 0 0.2rem`,
    borderColor: "#8c8c8c",
  },

  /* firefox */
  "&:focus-visible": {
    outline: 0,
  },
}));

export default StyledInputElement;